import { useSyncExternalStore } from 'react';

/** How often "6 minutes ago" moves on. */
const TICK_MS = 30_000;

let now = Date.now();
let timer: ReturnType<typeof setInterval> | undefined;
const listeners = new Set<() => void>();

function tick() {
  now = Date.now();
  for (const listener of listeners) {
    listener();
  }
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  if (timer === undefined) {
    // A clock that nobody watched may be old: bring it up to date for the first one who does.
    now = Date.now();
    timer = setInterval(tick, TICK_MS);
  }
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && timer !== undefined) {
      clearInterval(timer);
      timer = undefined;
    }
  };
}

const snapshot = () => now;

/**
 * The time, for relative wording ("indexed 6 minutes ago"), as a shared clock that ticks every half minute while
 * something shows it — read outside render, so rendering stays pure.
 */
export function useNow(): number {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}
